/**
 * Shared design tokens for the QRCard UI.
 * Color scales live in palette.json (also consumed by tailwind.config.js).
 */
import palette from "./palette.json";

export const colors = palette;

/** Brand primary (teal) — Tailwind `primary-600` */
export const BRAND_PRIMARY = palette.primary["600"];
/** Soft brand accent — Tailwind `primary-400` */
export const BRAND_SOFT = palette.primary["400"];
/** Mid brand teal — Tailwind `primary-500` (MUI focus borders, etc.) */
export const BRAND_MID = palette.primary["500"];
/** Deep brand teal — Tailwind `primary-700` */
export const BRAND_DEEP = palette.primary["700"];
/** Light wash used as QR / form secondary default */
export const BRAND_SOFT_BG = palette.qr.softBg;
/** Dark surface used in app dark mode / card mixes */
export const SURFACE_DARK = palette.surface["900"];
/** Slate-900 — default QR module / body ink */
export const INK_DEFAULT = palette.secondary["900"];
/** Finder-pattern dark teal */
export const QR_FINDER_DARK = palette.qr.finderDark;
/** Default QR module color */
export const QR_DEFAULT_DOT = palette.qr.defaultDot;

/** Default company/package branding when none is set (admin forms) */
export const DEFAULT_COMPANY_BRANDING = {
  primaryColor: BRAND_PRIMARY,
  secondaryColor: "#e5e7eb",
  fontColor: "#000000",
} as const;

/** Marketing demo card branding */
export const DEFAULT_DEMO_BRANDING = {
  primaryColor: BRAND_PRIMARY,
  secondaryColor: BRAND_SOFT,
  fontColor: "#ffffff",
} as const;

/** RGB form of BRAND_MID for MUI `sx` overrides */
export const BRAND_MID_RGB = "32 164 171";

export const fonts = {
  sans: ["Inter", "system-ui", "-apple-system", "sans-serif"],
  display: [
    "Manrope",
    "Poppins",
    "Inter",
    "system-ui",
    "-apple-system",
    "sans-serif",
  ],
} as const;

export const shadows = {
  soft: "0 2px 15px -3px rgba(0, 0, 0, 0.07), 0 10px 20px -2px rgba(0, 0, 0, 0.04)",
  elevated:
    "0 10px 25px -5px rgba(2, 6, 23, 0.15), 0 8px 10px -6px rgba(2, 6, 23, 0.1)",
  admin:
    "0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px -8px rgba(15, 23, 42, 0.08)",
  adminHover:
    "0 4px 12px -4px rgba(1, 135, 143, 0.18), 0 12px 28px -10px rgba(15, 23, 42, 0.12)",
  adminFocus: "0 0 0 4px rgba(1, 135, 143, 0.14)",
} as const;
